import styled, { breakpoints } from '../../../styles/theme';
import { CheckoutStepWizardStyled } from '../CheckoutStepWizardStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const CheckoutStepWizardDS = styled(CheckoutStepWizardStyled)`
    .progressWrapper {
        @media screen and (max-width: ${breakpoints.sm}px) {
            margin-top: ${rem('56px')};
            .progressBlock .progressCar {
                display: block;
            }
        }
        .progressBlock {
            .progressTimer {
                border: none;
            }
            &.progressBlockActive {
                .progressTitle,
                .progressTimer {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }
            }
            &.progressBlockCompleted::after {
                background-color: #ad0040;
            }
            &:first-child {
                &::before {
                    background-color: #ad0040;
                }
            }
            &:last-child {
                &.progressBlockCompleted::after {
                    background-color: #ad0040;
                }
                .progressTimer {
                    border: none;
                }
            }
        }
        .progressBlockCompleted {
            .progressTimer {
                color: #1a1b1b;
                border: none;
            }
            .progressStep span {
                color: #ad0040;
            }
            .progressTitle {
                color: #1a1b1b;
            }
        }
    }
`;
